import React from "react";
import { Outlet } from "react-router-dom";
import FrontHeader from "../../shared/FrontHeader";
import FrontFooter from "../../shared/FrontFooter";
import { setTitle } from "../../helpers/MetaTag";

const FrontLayout = ({ metaTitle }) => {
  setTitle(`HobbyConnect | ${metaTitle}`);
  return (
    <>
      <FrontHeader />
      <Outlet />
      <FrontFooter />
    </>
  );
};

export default FrontLayout;
